import { render, staticRenderFns } from "./NoFoundData.vue?vue&type=template&id=16b2b950"
import script from "./NoFoundData.vue?vue&type=script&lang=js"
export * from "./NoFoundData.vue?vue&type=script&lang=js"
import style0 from "./NoFoundData.vue?vue&type=style&index=0&id=16b2b950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports